import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungsArtKlasseListStatus: 'idle',
    loadMeldungsArtKlasseListError: undefined as any,
    loadMeldungsArtKlasseListLastArgs: undefined as any,
    loadMeldungsArtKlasseStatus: 'idle',
    loadMeldungsArtKlasseError: undefined as any,
    saveMeldungsArtKlasseStatus: 'idle',
    saveMeldungsArtKlasseError: undefined as any,
    deleteMeldungsArtKlasseStatus: 'idle',
    deleteMeldungsArtKlasseError: undefined as any,

    meldungsArtKlasseList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungsArtKlasseList = createAsyncThunk('meldungsArtKlasseSlice/loadMeldungsArtKlasseList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungsArtKlasseSlice.loadMeldungsArtKlasseListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldartklasse/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungsArtKlasseListStatus } = getState().meldungsArtKlasseSlice
        return loadMeldungsArtKlasseListStatus !== 'pending'
    }
})

export const loadMeldungsArtKlasse = createAsyncThunk('meldungsArtKlasseSlice/loadMeldungsArtKlasse', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldartklasse/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungsArtKlasseStatus } = getState().meldungsArtKlasseSlice
        return loadMeldungsArtKlasseStatus !== 'pending'
    }
})

export const saveMeldungsArtKlasse = createAsyncThunk('meldungsArtKlasseSlice/saveMeldungsArtKlasse', async ({ meldungsArtKlasse }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungsArtKlasse?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldartklasse/${ meldungsArtKlasse?.HDR_ID }/`,
            prepareData(meldungsArtKlasse),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldartklasse/`,
            prepareData(meldungsArtKlasse),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungsArtKlasseStatus } = getState().meldungsArtKlasseSlice
        return saveMeldungsArtKlasseStatus !== 'pending'
    }
})

export const deleteMeldungsArtKlasse = createAsyncThunk('meldungsArtKlasseSlice/deleteMeldungsArtKlasse', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldartklasse/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungsArtKlasseStatus } = getState().meldungsArtKlasseSlice
        return deleteMeldungsArtKlasseStatus !== 'pending'
    }
})

const MeldungsArtKlasseSlice = createSlice({
    name: 'meldungsArtKlasseSlice',
    initialState,
    reducers: {
        resetloadMeldungsArtKlasseListError: (state) => {
            state.loadMeldungsArtKlasseListError = undefined
        },
        resetloadMeldungsArtKlasse: (state) => {
            state.formItem = undefined
            state.loadMeldungsArtKlasseError = undefined
        },
        resetloadMeldungsArtKlasseError: (state) => {
            state.loadMeldungsArtKlasseError = undefined
        },
        resetsaveMeldungsArtKlasse: (state) => {
            state.formItem = undefined
            state.saveMeldungsArtKlasseError = undefined
        },
        resetsaveMeldungsArtKlasseError: (state) => {
            state.saveMeldungsArtKlasseError = undefined
        },
        resetdeleteMeldungsArtKlasseError: (state) => {
            state.deleteMeldungsArtKlasseError = undefined
        },
        removeFromMeldungsArtKlasseListById: (state, action) => {
            state.meldungsArtKlasseList = state.meldungsArtKlasseList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungsArtKlasseListByIds: (state, action) => {
            state.meldungsArtKlasseList = state.meldungsArtKlasseList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungsArtKlasseList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungsArtKlasseListStatus = 'preloaded'
            state.loadMeldungsArtKlasseListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungsArtKlasseList = []
            state.loadMeldungsArtKlasseListStatus = 'idle'
            state.loadMeldungsArtKlasseListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungsArtKlasseList.pending, (state) => {
            state.loadMeldungsArtKlasseListStatus = 'pending'
            state.loadMeldungsArtKlasseListError = undefined
        })
        builder.addCase(loadMeldungsArtKlasseList.fulfilled, (state, action) => {
            state.loadMeldungsArtKlasseListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungsArtKlasseListLastArgs = action.payload.args

            {
                state.meldungsArtKlasseList = action.payload.data

            }
        })
        builder.addCase(loadMeldungsArtKlasseList.rejected, (state, action) => {
            state.loadMeldungsArtKlasseListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungsArtKlasseListError = action.error.message
            } else {
                state.loadMeldungsArtKlasseListError = action.payload
            }
        })

        builder.addCase(loadMeldungsArtKlasse.pending, (state) => {
            state.loadMeldungsArtKlasseStatus = 'pending'
            state.loadMeldungsArtKlasseError = undefined
        })
        builder.addCase(loadMeldungsArtKlasse.fulfilled, (state, action) => {
            state.loadMeldungsArtKlasseStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungsArtKlasseList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungsArtKlasseList.push(newItem) }
                else { state.meldungsArtKlasseList[i] = { ...state.meldungsArtKlasseList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungsArtKlasse.rejected, (state, action) => {
            state.loadMeldungsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungsArtKlasseError = action.error.message
            } else {
                state.loadMeldungsArtKlasseError = action.payload
            }
        })

        builder.addCase(saveMeldungsArtKlasse.pending, (state) => {
            state.saveMeldungsArtKlasseStatus = 'pending'
            state.saveMeldungsArtKlasseError = undefined
        })
        builder.addCase(saveMeldungsArtKlasse.fulfilled, (state, action) => {
            state.saveMeldungsArtKlasseStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungsArtKlasseList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungsArtKlasseList.push(newItem) }
                else { state.meldungsArtKlasseList[i] = { ...state.meldungsArtKlasseList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungsArtKlasse.rejected, (state, action) => {
            state.saveMeldungsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungsArtKlasseError = action.error.message
            } else {
                state.saveMeldungsArtKlasseError = action.payload
            }
        })

        builder.addCase(deleteMeldungsArtKlasse.pending, (state) => {
            state.deleteMeldungsArtKlasseStatus = 'pending'
            state.deleteMeldungsArtKlasseError = undefined
        })
        builder.addCase(deleteMeldungsArtKlasse.fulfilled, (state, action) => {
            state.deleteMeldungsArtKlasseStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungsArtKlasseList = state.meldungsArtKlasseList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungsArtKlasseList = state.meldungsArtKlasseList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungsArtKlasse.rejected, (state, action) => {
            state.deleteMeldungsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungsArtKlasseError = action.error.message
            } else {
                state.deleteMeldungsArtKlasseError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungsArtKlasseListError,
    resetloadMeldungsArtKlasse,
    resetloadMeldungsArtKlasseError,
    resetsaveMeldungsArtKlasse,
    resetsaveMeldungsArtKlasseError,
    resetdeleteMeldungsArtKlasseError,
    removeFromMeldungsArtKlasseListById,
    removeFromMeldungsArtKlasseListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungsArtKlasseSlice.actions
export default MeldungsArtKlasseSlice.reducer
